import { builderCalistoHref, operateSurfaceHref } from "@/utils/contextUrl";

export function studioPaletteNewThreadHref(
  organizationId: string,
  agentId: string,
  applicationKey?: string | null,
): string {
  const href = builderCalistoHref(organizationId, agentId, { applicationKey });
  const next = new URLSearchParams(href.split("?")[1] || "");
  next.set("newThread", "1");
  return `/studio/chat?${next.toString()}`;
}

export function studioPaletteTravailInboxHref(input: {
  organizationId?: string | null;
  agentId?: string | null;
  applicationKey?: string | null;
}): string {
  return operateSurfaceHref("/run/travail/inbox", {
    organizationId: input.organizationId,
    applicationKey: input.applicationKey,
    agentId: input.agentId,
  });
}

export function filterStudioPaletteCommands<T extends { label: string; description: string }>(
  commands: T[],
  search: string,
): T[] {
  const query = search.trim().toLowerCase();
  if (!query) return commands;
  return commands.filter((item) =>
    `${item.label} ${item.description}`.toLowerCase().includes(query),
  );
}
